import script from "./Contacto.vue?vue&type=script&setup=true&lang=ts"
export * from "./Contacto.vue?vue&type=script&setup=true&lang=ts"

import "./Contacto.vue?vue&type=style&index=0&id=5bf7a1e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bf7a1e7"]])

export default __exports__